import { getConfig } from '../configService';

const DEFAULT_NAME = 'george';

function getPlatformName(): string {
  try {
    return getConfig().REACT_APP_NAME || DEFAULT_NAME;
  } catch {
    return DEFAULT_NAME;
  }
}

export function getGeorgeBase(): string {
  const name = getPlatformName();
  let env: string | undefined;
  try {
    env = getConfig().REACT_APP_ENVIRONMENT;
  } catch {
    env = undefined;
  }
  if (env === 'prod') return `https://${name}.tiffany.com`;
  if (env === 'qa') return `https://${name}-qa.tiffany.com`;
  return `https://${name}-dev.tiffany.com`;
}

export const georgeUrl = (path: string) => `${getGeorgeBase()}/${path}`;

/**
 * Base URL of the supervisor agent.
 *
 * Local dev override: set `REACT_APP_SUPERVISOR_URL` in `.env.local` to
 * point at a locally-running supervisor (e.g. `http://localhost:8080`).
 * Otherwise resolves to George's `/chat/backend` reverse-proxied path.
 */
export const supervisorBase = () => {
  const override = (process.env as Record<string, string | undefined>).REACT_APP_SUPERVISOR_URL;
  if (override) return override.replace(/\/$/, '');
  return `${getGeorgeBase()}/chat/backend`;
};
